<div class="mt-3 mb-3" data-cy="auto-renewal-opt-in-checkbox">
  <om-checkbox
    id="double-opt-in-checkbox"
    [checkboxLabel]="consentText"
    (checked)="checked.emit($event)"
    aria-describedby="double-opt-in-alert"
  ></om-checkbox>
  <div
    *ngIf="showError"
    class="error-message mt-3 auto-renewal-error"
    data-cy="auto-renewal-opt-in-error"
    id="double-opt-in-alert"
  >
    <om-svg-triangle-error alt=""></om-svg-triangle-error>{{ inlineErrorText }}
  </div>
</div>
